/* eslint-disable react/no-multi-comp, react/prefer-stateless-function, prettier/prettier */
//
import PropTypes from "prop-types"
import React, { Component } from "react"

import {
    createNumericTripletMultiFilter,
    createPacContributionTotalFilter,
    createProfileToggleSingleFilter,
    datePickerGenericFilter,
    dateRangePickerFilter,
    enumOrderSort,
    enumSingleGenericFilter,
    // sorting functions
    enumValueSort,
    textGenericFilter,
} from "shared/search/containers/Filter/Filters"
import {
    searchifySelectGenericFilter,
    enumGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    BillFilterableListView,
    BulkSMSFilterableListView,
    BulkUploadFileFLV,
    CampaignSearchifyFLV,
    GrassrootsActionFilterableListView,
    IssueManagementFilterableListView,
    LegislatorSearchifyFLV,
    PublicOrganizationFilterableListView,
    SupporterLegislatorSearchifyFLV,
    UserFilterableListView,
    PoliticalCommitteeCampaignFinanceFilterableListView,
    LegislatorSearchifyWithoutCampaignFinanceFLV,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    ActionCenterSettingsSelect,
    ActiveCampaignSelect,
    BillSelect,
    BulkSMSSelect,
    BulkUploadFileSelect,
    CustomEventSelect,
    GrassrootsActionSelect,
    GrassrootsRegistrationPageSelect,
    IssueManagementSelect,
    LegislatorSelect,
    PublicOrganizationSelect,
    SupporterCampaignFinanceLegislatorSelect,
    TransactionSelect,
    PoliticalCommitteeCampaignFinanceSelect,
    UserSelect,
    LegislatorSelectWithoutCampaignFinance,
} from "app/static/frontend/selects/containers/PieSelect"

import { allRegionsExceptLocal } from "shared/imports/regionConstants"

import {
    DateListNoFutureSelect,
    SupporterActionTypeSelect,
    SupporterSourceSelect,
} from "app/static/frontend/selects/containers/EnumSelect"
import isFeatureEnabled from "shared/featureflags/helperFunctions"
import { MAX_BILL_SEARCHIFY_SELECTIONS } from "shared/search/constants"

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,
    helpText: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}

export class SupporterIsGrassrootsContactFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterGrassrootsContactFilter",
        filterKey: "grassroots_supporter",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Is a Grassroots Supporter...",
        helpText:
            "This is all Contacts who have logged into the Action Center, not just all Contacts who have taken action.",
        permissions: [DjangIO.app.models.PermissionType.action_center],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterIsStakeholderContactFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterStakeholderFilter",
        filterKey: "is_stakeholder_supporter",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Is a Stakeholder Supporter...",
        helpText:
            "This is a default field created by Quorum to distinguish your Grassroots and Stakeholder supporters. To update this field, visit our Help Center to learn how to do a bulk upload of custom fields.",
        permissions: [DjangIO.app.models.PermissionType.action_center],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterOrganizationFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterOrgFilter",
            filterKey: "public_orgs",
            dataTypeLabel: "Organizations",
            searchifyFLV: PublicOrganizationFilterableListView,
            selectComponent: PublicOrganizationSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class SupporterOrganizationsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterOrgsFilter",
            filterKey: "public_organizations_filter",
            dataTypeLabel: "Organizations",
            searchifyFLV: PublicOrganizationFilterableListView,
            selectComponent: PublicOrganizationSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasNameFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterHasName",
        displayLabel: "Search by Name",
        filterKey: "has_name",
        trueText: "Has Name",
        falseText: "Has No Name",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasPhoneNumberFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterHasPhoneNumber",
        displayLabel: "Search by Phone Number",
        filterKey: "has_phone_number",
        trueText: "Has Phone Number",
        falseText: "Has No Phone Number",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterSearchByCollaboratorFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterSearchByCollaborator",
        displayLabel: "Search by Collaborator",
        filterKey: "search_by_collaborator",
        trueText: "Collaborators only",
        falseText: "Exclude Collaborators",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterTitleFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "supporterTitleText",
        filterKey: "title_search",
        placeholderText: "Search text of title...",
        displayLabel: "Search Titles",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterLegislatorFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterLegislatorFilter",
            filterKey: "represented_by",
            searchifyFLV: LegislatorSearchifyWithoutCampaignFinanceFLV,
            dataTypeLabel: "Legislators",
            selectComponent: LegislatorSelectWithoutCampaignFinance,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterLastActionDateFilter extends Component {
    static defaultProps = {
        filterKey: "last_action_custom_date_range",
        filterComponent: dateRangePickerFilter,
        uniqueFilterId: "supporterLastActionFilter",
        displayLabel: "Last Action Date",
        noFuture: true,
        helpText: "Filters supporters who performed actions given a period",
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const AdvocatesNumActionsAggregateFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "AdvocatesNumActionsAggregateFilter",
    displayLabel: "Number of Actions Taken",
    filterKeyMapping: {
        left: "num_actions__lt",
        center: "num_actions__exact",
        right: "num_actions__gt",
    },
})

export const AdvocatesNumCampaignsInteractedFilter = createNumericTripletMultiFilter({
    uniqueFilterId: "AdvocatesNumCampaignsInteractedFilter",
    displayLabel: "Number of Campaigns Interacted In",
    filterKeyMapping: {
        left: "num_campaigns_interacted__lt",
        center: "num_campaigns_interacted__exact",
        right: "num_campaigns_interacted__gt",
    },
})

export class SupporterLastKindActionFilter extends Component {
    static get defaultProps() {
        const pacCondition = window.Userdata?.can_access_pac && isFeatureEnabled("ff_pac")
        const excludedValues = [
            DjangIO.app.userdata.types.GrassrootsInteractionType.registered.value,
            DjangIO.app.userdata.types.GrassrootsInteractionType.scheduled.value,
            DjangIO.app.userdata.types.GrassrootsInteractionType.registration_form_registered.value,
            ...[
                !pacCondition
                    ? DjangIO.app.userdata.types.GrassrootsInteractionType.authorized_contribution.value
                    : null,
            ],
        ]

        const grassrootsInteractions = DjangIO.app.userdata.types.GrassrootsInteractionType.filter_groups
            .find((group) => group.title === "Grassroots")
            .values.filter((item) => !excludedValues.includes(item))

        return {
            filterComponent: enumGenericFilter,
            uniqueFilterId: "supporterLastKindActionGroup",
            filterKey: `last_kind_action__in`,
            enumItems: DjangIO.app.userdata.types.GrassrootsInteractionType.region_supported_items().filter((item) =>
                grassrootsInteractions?.includes(item.value),
            ),
            selectComponent: SupporterActionTypeSelect,
            sortBy: enumOrderSort,
            displayLabel: "Last Kind Action",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterCampaignFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterCampaignFilter",
            filterKey: "involved_in_campaigns",
            searchifyFLV: CampaignSearchifyFLV,
            searchifyPermanentFilter: {
                status__in: [
                    DjangIO.app.grassroots.campaign.types.CampaignStatus.active.value,
                    DjangIO.app.grassroots.campaign.types.CampaignStatus.complete.value,
                ],
            },
            dataTypeLabel: "Campaigns",
            displayLabel: "Participated in campaigns...",
            selectComponent: ActiveCampaignSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterNotCampaignFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterNotCampaignFilter",
            filterKey: "not_involved_in_campaigns",
            searchifyFLV: CampaignSearchifyFLV,
            searchifyPermanentFilter: {
                status__in: [
                    DjangIO.app.grassroots.campaign.types.CampaignStatus.active.value,
                    DjangIO.app.grassroots.campaign.types.CampaignStatus.complete.value,
                ],
            },
            dataTypeLabel: "Campaigns",
            displayLabel: "Didn't participate in campaigns...",
            selectComponent: ActiveCampaignSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterParticipatedInAnyCampaignFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterAnyCampaignFilter",
        filterKey: "participated_in_any_campaign",
        trueText: "Any Campaign",
        falseText: "No Campaign",
        displayLabel: "Participated in...",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterSharedAnyCampaignOnSocialFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterCampaignSocialFilter",
        filterKey: "shared_any_campaign_on_social",
        trueText: "Any Campaign",
        falseText: "No Campaign",
        displayLabel: "Shared...",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const SupporterInteractedInGrassrootsActionFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent searchifyFLV={GrassrootsActionFilterableListView} {...props} />
}
SupporterInteractedInGrassrootsActionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "supporterInGrassrootsAction",
    filterKey: "participated_in_grassroots_actions",
    displayLabel: "Took particular actions...",
    helpText:
        "Use Search to select a set of grassroots actions (from a certain time period, for example). " +
        "This filter will then show only the individuals who performed those particular actions.",
    dataTypeLabel: "Actions",
    selectComponent: GrassrootsActionSelect,
}

export const SupporterTargetedByCampaignFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent searchifyFLV={CampaignSearchifyFLV} {...props} />
}
SupporterTargetedByCampaignFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "supporterTargetedByCampaignFilter",
    filterKey: "for_campaigns",
    displayLabel: "Targeted by campaign...",
    helpText: "Use Search to select contacts targeted by specific campaigns",
    dataTypeLabel: "Campaigns",
    selectComponent: ActiveCampaignSelect,
}

export class SupporterUpdatedDateListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "supporterUpdatedDateListFilter",
        filterKey: "date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.events.models.DateRangeType.future.value,
                    DjangIO.app.events.models.DateRangeType.next_month.value,
                    DjangIO.app.events.models.DateRangeType.next_week.value,
                ].includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoFutureSelect,
        displayLabel: "Date Updated",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterUpdatedDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "supporterUpdatedDateStart",
        filterKey: "updated__gt",
        displayLabel: "Last Updated After",
        noFuture: true,
        helpText: "Contacts last updated after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterUpdatedDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "supporterUpdatedDateEnd",
        filterKey: "updated__lt",
        displayLabel: "Last Updated Before",
        noFuture: true,
        helpText: "Contacts last updated before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterCreatedDateListFilter extends Component {
    static defaultProps = {
        filterComponent: enumSingleGenericFilter,
        uniqueFilterId: "supporterCreatedDateListFilter",
        filterKey: "created_date_range",
        enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.events.models.DateRangeType.future.value,
                    DjangIO.app.events.models.DateRangeType.next_month.value,
                    DjangIO.app.events.models.DateRangeType.next_week.value,
                ].includes(item.value),
        ),
        sortBy: enumOrderSort,
        selectComponent: DateListNoFutureSelect,
        displayLabel: "Date Created",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterCreatedDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "supporterCreatedDateStart",
        filterKey: "created__gt",
        displayLabel: "Created After",
        noFuture: true,
        helpText: "Contacts created after date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterCreatedDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "supporterCreatedDateEnd",
        filterKey: "created__lt",
        displayLabel: "Created Before",
        noFuture: true,
        helpText: "Contacts created before date selected. Excludes date selected.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterRecentlyActiveEmailFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterRecentlyActiveEmail",
        filterKey: "recently_active_email_recipient",
        displayLabel: "Email Activity",
        trueText: "Active Recipient",
        falseText: "Inactive Recipient",
        helpText:
            "Break down your list of contacts by the degree to which they " +
            "interact with your emails. Active recipients have valid emails, haven't unsubscribed " +
            "from your emails, and have either opened or clicked an email of yours in the last 120 days " +
            "or were recently added to Quorum. " +
            "This metric is updated daily, so if you've recently sent an email you may not see this result change " +
            "until the following day.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasReceivedEmailFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterHasReceivedEmail",
        filterKey: "has_ever_received_an_email",
        trueText: "Received Email Before",
        falseText: "Never Been Emailed",
        helpText: "Break down your list of contacts by whether you have ever sent them an Outbox email before.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterValidEmailFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterValidEmail",
        filterKey: "has_valid_email",
        trueText: "Valid Email",
        falseText: "Invalid Email",
        displayLabel: "Search by Email",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterLastModifiedByFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterLastModifiedBy",
            filterKey: "last_modified_by",
            searchifyFLV: UserFilterableListView,
            dataTypeLabel: "Team Members",
            selectComponent: UserSelect,
            displayLabel: "Last Modified By...",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class SupporterSourceFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "supporterSourceFilter",
        filterKey: "source_type__in",
        enumItems: DjangIO.app.grassroots.types.UTMSourceType.region_supported_items().filter(
            (item) => item.relevant_to_contacts,
        ),
        sortBy: enumValueSort,
        selectComponent: SupporterSourceSelect,
        displayLabel: "Original Contact Source",
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterUTMSourceFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "supporterUTMSourceFilter",
        filterKey: "utm_combined_filter",
        placeholderText: "Search by custom link parameter...",
        displayLabel: "Custom Link Parameter",
        helpText:
            "Search for contacts that subscribed in the Action Center with particular utm parameters." +
            " This filter searches all of utm_source, utm_medium, utm_campaign, utm_term, and utm_content.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class SupporterFromBulkUploadFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterFromBulkUploadFilter",
            filterKey: "from_bulk_upload_files",
            searchifyFLV: BulkUploadFileFLV,
            searchifyPermanentFilter: {
                upload_type: DjangIO.app.custom_data.types.BulkUploadType.supporter.value,
                status: DjangIO.app.custom_data.types.BulkUploadStatus.finished.value,
            },
            dataTypeLabel: "Custom Contact Bulk Uploads",
            displayLabel: "Bulk upload files...",
            selectComponent: BulkUploadFileSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

// Profile-specfic filters
export const SupporterOrganizatonsFilter = createProfileToggleSingleFilter({
    uniqueFilterId: "supporterOrganizatonsFilter",
    trueText: "Current Org Only",
    filterKeyMapping: {
        true: "associated_with_organization",
    },
})

// Custom Events filters
export const SupporterCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterCustomEventFilter.propTypes = defaultPropTypes
SupporterCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "supporterCustomEventFilter",
    filterKey: "involved_in_event_searchify",
    dataTypeLabel: "Added to Event",
    displayLabel: "Added to Event",
    selectComponent: CustomEventSelect,
}

export const SupporterInvitedToEventCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterInvitedToEventCustomEventFilter.propTypes = defaultPropTypes
SupporterInvitedToEventCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialInvitedToEventCustomEventFilter",
    filterKey: "invited_to_event_searchify",
    dataTypeLabel: "Emailed About Event",
    displayLabel: "Emailed About Event",
    selectComponent: CustomEventSelect,
}

export const SupporterHasNotRsvpCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterHasNotRsvpCustomEventFilter.propTypes = defaultPropTypes
SupporterHasNotRsvpCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasNotRsvpCustomEventFilter",
    filterKey: "has_not_rsvped_searchify",
    dataTypeLabel: "Has Not not RSVP'd to Event",
    displayLabel: "Has Not RSVP'd to Event",
    selectComponent: CustomEventSelect,
}

export const SupporterHasRsvpYesCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterHasRsvpYesCustomEventFilter.propTypes = defaultPropTypes
SupporterHasRsvpYesCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasRsvpYesCustomEventFilter",
    filterKey: "has_rsvped_yes_searchify",
    dataTypeLabel: "RSVP'd Yes to Event",
    displayLabel: "RSVP'd Yes to Event",
    selectComponent: CustomEventSelect,
}

export const SupporterHasRsvpNoCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterHasRsvpNoCustomEventFilter.propTypes = defaultPropTypes
SupporterHasRsvpNoCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasRsvpNoCustomEventFilter",
    filterKey: "has_rsvped_no_searchify",
    dataTypeLabel: "RSVP'd No to Event",
    displayLabel: "RSVP'd No to Event",
    selectComponent: CustomEventSelect,
}

export const SupporterHasRsvpMaybeCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterHasRsvpMaybeCustomEventFilter.propTypes = defaultPropTypes
SupporterHasRsvpMaybeCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialHasRsvpMaybeCustomEventFilter",
    filterKey: "has_rsvped_maybe_searchify",
    dataTypeLabel: "RSVP'd Maybe to Event",
    displayLabel: "RSVP'd Maybe to Event",
    selectComponent: CustomEventSelect,
}

export const SupporterAttendedCustomEventFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
SupporterAttendedCustomEventFilter.propTypes = defaultPropTypes
SupporterAttendedCustomEventFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "officialAttendedCustomEventFilter",
    filterKey: "attended_event_searchify",
    dataTypeLabel: "Attended Event",
    displayLabel: "Attended Event",
    selectComponent: CustomEventSelect,
}

export const SupporterProjectFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={IssueManagementFilterableListView} {...props} />
}
SupporterProjectFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
SupporterProjectFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "supporterProjectFilter",
    filterKey: "for_project_and_subprojects",
    dataTypeLabel: "Issues",
    selectComponent: IssueManagementSelect,
}

export class SupporterAssigneeOfOfficialFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterAssigneeOfOfficialFilter",
            displayLabel: "Is assignment of official...",
            searchifyFLV: LegislatorSearchifyFLV,
            selectComponent: LegislatorSelect,
            filterKey: "assignee_of_official_searchify",
            permissions: [
                DjangIO.app.models.PermissionType.legislators,
                DjangIO.app.models.PermissionType.executives,
                DjangIO.app.models.PermissionType.staffers,
            ],
            helpText: "Filter contacts by the officials they are the assignees of.",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterAssigneeOfBillFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterAssigneeOfBillFilter",
            displayLabel: `Is assignment of ${DjangIO.app.models.QuorumDataType.bill.label}...`,
            searchifyFLV: BillFilterableListView,
            selectComponent: BillSelect,
            filterKey: "assignee_of_bill_searchify",
            regions: allRegionsExceptLocal,
            helpText: "Filter contacts by the bills they are the assignees of.",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterPhoneNumberFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "supporterPhoneNumberFilter",
        filterKey: "phone_number_search",
        placeholderText: "Search by phone number...",
        displayLabel: "Search by phone number",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterSecondaryPhoneNumberFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "supporterSecondaryPhoneNumberFilter",
        filterKey: "secondary_phone_number_search",
        placeholderText: "Search by secondary phone number...",
        displayLabel: "Search by secondary phone number",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterUniqueIdentifierFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "supporterUniqueIdentifierFilter",
        filterKey: "unique_identifier_search",
        placeholderText: "Search by unique identifier...",
        displayLabel: "Search by unique identifier",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const SupporterEmailFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
SupporterEmailFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    placeholderText: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
SupporterEmailFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "supporterEmailFilter",
    filterKey: "email_search",
    placeholderText: "Search by email address...",
    displayLabel: "Search by Email Address",
    helpText: "You can search for text contained in multiple email addresses by separating your inputs with a comma",
}

export class ActionCenterSourceFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            selectComponent: ActionCenterSettingsSelect,
            uniqueFilterId: "supporterActionCenterSourceFilter",
            filterKey: "action_center_source",
            displayLabel: "Action Center Source",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class ActionCenterInteractionsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            selectComponent: ActionCenterSettingsSelect,
            uniqueFilterId: "supporterActionCenterInteractionsFilter",
            filterKey: "action_center_interactions",
            displayLabel: "Action Centers Visited",
            helpText: "All Action Centers with which a contact has engaged",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RegistrationFormSourceFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            selectComponent: GrassrootsRegistrationPageSelect,
            uniqueFilterId: "supporterRegistrationFormSourceFilter",
            filterKey: "registration_form_source_filter",
            displayLabel: "Registration Form Source",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RegistrationFormInteractionsFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            selectComponent: GrassrootsRegistrationPageSelect,
            uniqueFilterId: "supporterRegistrationFormInteractionsFilter",
            filterKey: "registration_form_interactions_filter",
            displayLabel: "Registration Forms Used",
            helpText: "All registration forms that a contact has completed, across any Action Center",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class RegisteredWithTextKeywordFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: textGenericFilter,
            uniqueFilterId: "supporterRegisteredWithTextKeywordFilter",
            filterKey: "registered_with_text_keyword_filter",
            placeholderText: "Search by keyword...",
            displayLabel: "Registered with Text Keyword",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterTransactionFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterTransactionFilter",
            filterKey: "supporter_transaction",
            dataTypeLabel: "Search for Contacts with Transactions",
            displayLabel: "Search for Contacts with Transactions",
            selectComponent: TransactionSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const SupporterPacContributionTotalFilter = createPacContributionTotalFilter({
    uniqueFilterId: "pacContributionTotalFilter",
    displayLabel: "Search for Contacts with an Aggregate Receipt Total",
    filterKeyMapping: { left: "amount_less_than", center: "amount_is_exactly", right: "amount_greater_than" },
})

export class SupporterSubmittedAnyFacebookLead extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterSubmittedAnyFacebookLead",
        filterKey: "submitted_any_facebook_lead",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Submitted a Facebook Lead...",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class AdvocateIsActiveFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "advocateIsActiveFilter",
        filterKey: "is_active",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Is Active...",
        helpText:
            "Filter by contacts who had opened an email or visited a page at the action center within the last 12 months.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SubscribedTextFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "subscribedText",
        displayLabel: "Status",
        filterKey: "has_text_subscribed",
        trueText: "Subscribed",
        falseText: "Not subscribed",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasEverBeenSentTextFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterHasBeenSentText",
        filterKey: "has_ever_been_sent_text",
        trueText: "Been Sent Text Before",
        falseText: "Never Been Texted",
        displayLabel: "History",
        helpText: "Break down your list of contacts by whether you have ever sent them a text before.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasBeenSentSpecificTextFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Has been sent text...",
            filterComponent: searchifySelectGenericFilter,
            filterKey: "has_been_sent_specific_text",
            searchifyFLV: BulkSMSFilterableListView,
            selectComponent: BulkSMSSelect,
            uniqueFilterId: "supporterHasBeenSentSpecificText",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterHasOpenedTextFilter extends Component {
    static get defaultProps() {
        return {
            displayLabel: "Has clicked link in text...",
            filterComponent: searchifySelectGenericFilter,
            filterKey: "has_opened_text",
            searchifyFLV: BulkSMSFilterableListView,
            selectComponent: BulkSMSSelect,
            uniqueFilterId: "supporterHasOpenedText",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterTextDateSentFilter extends Component {
    static defaultProps = {
        filterKey: "text_sent_custom_date_range",
        filterComponent: dateRangePickerFilter,
        uniqueFilterId: "supporterTextDateSentFilter",
        displayLabel: "Date Sent",
        noFuture: true,
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class SupporterTextSentAfterFilter extends Component {
    static defaultProps = {
        filterKey: "texting_sent_after",
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "supporterTextSentAfterFilter",
        displayLabel: "Sent After",
        noFuture: true,
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterTextSentBeforeFilter extends Component {
    static defaultProps = {
        filterKey: "texting_sent_before",
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "supporterTextSentBeforeFilter",
        displayLabel: "Sent Before",
        noFuture: true,
    }
    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class SupporterCampaignFinanceHasContributedFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "supporterCampaignFinanceHasContributedFilter",
        filterKey: "campaign_finance_has_contributed",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Has contributed...",
        helpText: "Filter by contacts who have contributed at least once.",
        permissions: [
            DjangIO.app.models.PermissionType.campaign_finance,
            DjangIO.app.models.PermissionType.can_access_campaign_finance,
        ],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterCampaignFinanceLegislatorFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "supporterCampaignFinanceLegislatorFilter",
            filterKey: "campaign_finance_legislator_receivers",
            searchifyFLV: SupporterLegislatorSearchifyFLV,
            displayLabel: "Has Contributed To",
            dataTypeLabel: "Official",
            selectComponent: SupporterCampaignFinanceLegislatorSelect,
            permissions: [
                DjangIO.app.models.PermissionType.campaign_finance,
                DjangIO.app.models.PermissionType.can_access_campaign_finance,
            ],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class SupporterCampaignFinanceReceiptsContributorCommitteesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "receipts_campaign_finance_receiptsContributorCommitteesFilter",
            filterKey: "receipts_contributor_committee_name",
            dataTypeLabel: "ReceiptContributorCommittee",
            searchifyFLV: PoliticalCommitteeCampaignFinanceFilterableListView,
            selectComponent: PoliticalCommitteeCampaignFinanceSelect,
            displayLabel: "Has Contributed To",
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
